import { render, staticRenderFns } from "./CercaIndirizzo.vue?vue&type=template&id=5195d899&lang=pug&"
import script from "./CercaIndirizzo.vue?vue&type=script&lang=ts&"
export * from "./CercaIndirizzo.vue?vue&type=script&lang=ts&"
import style0 from "./CercaIndirizzo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports